// src/services/CountryService.js
import api from "./api";

export function getApplication(page = 1, limit = 10, search = "") {
    return api.get(`/application?page=${page}&limit=${limit}&search=${search}`);
}

export function getApplicationById(id) {
    return api.get(`/application/${id}`);
}

export function addApplication(data) {
    return api.post("/application", data);
}

export function updateApplication(id, data) {
    return api.put(`/application/${id}`, data);
}

export function deleteApplication(id) {
    return api.delete(`/application/${id}`);
}
